export default __webpack_public_path__ + "static/media/paymentBanner.90328021.png";